module.exports = __webpack_public_path__ + "static/media/Asset-19.d55045de.svg";